<template>
  <div class="translate-button" v-if="! UIFlags.isFetching">
    <button
      v-if="shouldButtonShow"
      class="button smooth button--only-icon small secondary"
      type="submit"
      v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_TRANSLATE_ICON')"
      @click="handleButtonClick"
    >
      <svg version="1.0" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 600 450" style="enable-background:new 0 0 600 450;" xml:space="preserve">
        <g id="_xD83D__xDDA5_-Welab.bank-pre-launch-desktop">
          <g id="_x31_" transform="translate(-1066.000000, -38.000000)">
            <path id="Fill-1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#010202;" d="M1420.7,284.1c-5-6.7-8.3-12.7-10.3-17.1h20.6C1429,271.4,1425.8,277.3,1420.7,284.1
              L1420.7,284.1z M1448.6,251.6h-20.1v-7.2c0-4.2-3.4-7.7-7.7-7.7c-4.2,0-7.7,3.4-7.7,7.7v7.2h-20.1c-4.2,0-7.7,3.4-7.7,7.7
              c0,4.2,3.4,7.7,7.7,7.7h1c2,5.7,6.6,16.5,16.6,29c-4.2,4.2-9.1,8.5-14.9,12.7c-3.4,2.5-4.2,7.3-1.7,10.8c1.5,2.1,3.8,3.1,6.2,3.1
              c1.6,0,3.2-0.5,4.5-1.5c6.2-4.5,11.5-9.2,16.1-13.7c4.6,4.6,9.9,9.2,16.1,13.7c1.4,1,3,1.5,4.5,1.5c2.4,0,4.7-1.1,6.2-3.1
              c2.5-3.4,1.8-8.2-1.7-10.8c-5.8-4.2-10.7-8.5-14.9-12.7c9.9-12.5,14.6-23.4,16.6-29h1c4.2,0,7.7-3.4,7.7-7.7
              C1456.3,255,1452.8,251.6,1448.6,251.6L1448.6,251.6z M1467.5,353.6c0,7.3-5.9,13.2-13.2,13.2h-94.1c-0.9,0-1.8-0.3-2.7-0.5
              l25.1-33.5c0.4-0.5,0.5-1.1,0.8-1.6c0.2-0.3,0.4-0.6,0.5-1c0.3-1,0.4-2.1,0.2-3.1v0L1365.1,198h89.1c7.3,0,13.2,5.9,13.2,13.2
              V353.6z M1361,335.9l-14.1,18.8l-2.1-18.8H1361z M1264.8,307.3V173.2c0-7.3,5.9-13.2,13.2-13.2h54.6c6.5,0,12.2,4.9,13.1,11.3
              l21.8,149.3H1278C1270.7,320.5,1264.8,314.6,1264.8,307.3L1264.8,307.3z M1454.3,182.6h-91.4l-2-13.6c-2-13.9-14.2-24.5-28.3-24.5
              H1278c-15.8,0-28.6,12.8-28.6,28.6v134.1c0,15.8,12.8,28.6,28.6,28.6h51.4l2.3,20.9c1.6,14.5,13.8,25.4,28.4,25.4h94.1
              c15.8,0,28.6-12.8,28.6-28.6V211.2C1482.9,195.5,1470,182.6,1454.3,182.6L1454.3,182.6z M1301.7,245.9l5.5-28.5
              c0.5-2.3,4.4-2.3,4.8,0l5.5,28.5H1301.7z M1309.6,200c-8.5,0-15.9,6.1-17.5,14.5l-11.7,60.8c-0.8,4.2,1.9,8.2,6.1,9
              c4.1,0.8,8.2-1.9,9-6.1l3.3-16.9h21.8l3.3,16.9c0.7,3.7,3.9,6.2,7.5,6.2c0.5,0,1,0,1.5-0.1c4.2-0.8,6.9-4.9,6.1-9l-11.7-60.8
              C1325.5,206.1,1318.1,200,1309.6,200L1309.6,200z"/>
          </g>
        </g>
      </svg>
    </button>
    
    <woot-context-menu
      v-if="showContextMenu"
      :x="contextMenuPosition.x"
      :y="contextMenuPosition.y"
    >
      <div class="menu-container">
        <div class="menu-container-heading">{{ $t('CONVERSATION.REPLYBOX.CONTEXT_MENU_HEADING') }}</div>

        <hr />
           
        <menu-item
          v-for="language in this.languages" :key="language.locale"
          :option="{
            label: language.label,
          }"
          @click="handleTranslate(language.locale)"
        />

        <hr />
      </div>
    </woot-context-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuItem from '../widgets/conversation/contextMenu/menuItem.vue';
import TranslationsAPI from 'dashboard/api/translations';

export default {
  components: {
    MenuItem,
  },

  props: {
     message: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      showContextMenu: false,
      contextMenuPosition: {},
      languages: [
        {
          locale: 'zh_TW',
          label: '中国語（繁体）'
        },
        {
          locale: 'ja',
          label: '日本語'
        },
        {
          locale: 'en',
          label: '英語'
        }
      ] 
    };
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
      getIntegration: 'integrations/getIntegration',
      UIFlags: 'integrations/getUIFlags',
    }),
    shouldButtonShow() {
      const { locale } = this.getAccount(this.currentAccountId);
      const integration = this.getIntegration('google_translate');

      return locale === 'ja' && integration.enabled && integration.hooks[0].status;
    }
  },

  methods: {
    checkButtonShowable() {
      const integration = this.getIntegration('google_translate');
      const { locale } = this.getAccount(this.currentAccountId);

      console.log(integration, locale);
      this.shouldButtonShow = locale === 'ja' && integration.enabled && integration.hooks[0].status;
    },
    handleButtonClick(e) {
      this.openContextMenu(e);
    },
    openContextMenu(e) {
      this.contextMenuPosition = {
        x: (e.pageX || e.clientX) + 20,
        y: (e.pageY || e.clientY) - 120,
      };

      this.showContextMenu = ! this.showContextMenu;
    },
    closeContextMenu() {
      this.showContextMenu = false;

      this.contextMenuPosition = { x: null, y: null };
    },
    async handleTranslate(locale) {
      this.closeContextMenu();
      
      if (this.message === '') {
        return;
      }

      const { translated_content } = await this.$store.dispatch('translations/translate', {
        locale: locale,
        content: this.message
      });

      if (translated_content) {
        this.$emit('replace-text', translated_content);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-container {
  @apply p-1 bg-white dark:bg-slate-900 shadow-xl rounded-md;

  hr:first-child {
    @apply hidden;
  }

  hr {
    @apply m-1 border-b border-solid border-slate-50 dark:border-slate-800/50;
  }

  .menu-container-heading {
    padding: 0.25rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    font-weight: 500;
    font-size: 14px;
  }
}
</style>